import { loginRadiusStore } from "@/store/loginRadiusStore";
import type { LiveRampModule } from "@/ts/module";
import type { Exactly } from "@/ts/types";
import { appendHtmlToHead } from "@/utils/dom";
import { getModules } from "@/utils/modules";
import { REQUIRED_PURPOSES } from "@/utils/requiredGvl";
import { LIVERAMP_TAG } from "@/vendors/liveRamp";
import { LiveRamp as LiveRampVendor } from "@trinitymirrordigital/consent-helper/iab-gvl";
const loadScript = () => {
    appendHtmlToHead(LIVERAMP_TAG);
};
const ready = async (): Promise<boolean> => {
    const maxWait = 500;
    let waitingTimeRemaining: number = maxWait;
    return new Promise((resolve) => {
        const checkConditions = () => {
            if (window.atsenvelopemodule) {
                resolve(true);
            }
            else {
                waitingTimeRemaining -= 100;
                if (waitingTimeRemaining <= 0) {
                    resolve(true);
                }
                setTimeout(checkConditions, 100);
            }
        };
        checkConditions();
    });
};
const identify = (): void => {
    const state = loginRadiusStore.getState();
    const email = state.email;
    if (email) {
        window.atsenvelopemodule?.setAdditionalData({
            type: "email",
            id: email,
        });
    }
};
const updateEmailOnEmailChange = (): void => {
    loginRadiusStore.subscribe((state) => state.email, identify);
};
export class LiveRamp implements Exactly<LiveRampModule, LiveRamp> {
    name = "LiveRamp" as const;
    async init(): Promise<void> {
        const [consentModule] = await getModules(["Consent"]);
        const consented = await consentModule.run({
            vendorId: LiveRampVendor,
            purposes: REQUIRED_PURPOSES,
        });
        if (consented) {
            loadScript();
            await ready();
            identify();
            updateEmailOnEmailChange();
        }
    }
}
